import React from 'react'
import Head from 'next/head'
import ScanNowPage from '@src/routes/ScanNow'
import ScanNowOffline from '@src/routes/ScanNow/ScanNowOffline'
import { useCurrentUser } from '@utils/useCurrentUser'
import { useIntl } from 'react-intl'

const ScanNow = () => {
  const intl = useIntl()
  const { currentUser } = useCurrentUser()
  const isScanNowEnabled = Boolean(currentUser?.metadata?.isScanNowEnabled)

  const ScanNowRoute = isScanNowEnabled ? ScanNowPage : ScanNowOffline

  return (
    <React.Fragment>
      <Head>
        <title>
          {intl.formatMessage({ id: 'SCAN_NOW', defaultMessage: 'Scan Now' })}
        </title>
      </Head>
      <ScanNowRoute />
    </React.Fragment>
  )
}

export default ScanNow
